import HistorialMovimientosCliente from 'akasia-components/cliente/HistorialMovimientosCliente';
import ErrorBoundary from 'components/common/ErrorBoundary';
import PageHeader from 'components/common/PageHeader';
import React, { useState } from 'react';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ModalSeguimientoLead from '../leads/ModalSeguimientoLead';
import ModalDatosFiscalesIncompletos from './ModalDatosFiscalesIncompletos';
import OrdenesCliente from './OrdenesCliente';
import SeccionArchivosCliente from './SeccionArchivo';
import SoporteTecnico from './seccion-soporte-tecnico/SoporteTecnico';
import { FiUser, FiFileText, FiBriefcase, FiCode, FiHeadphones } from 'react-icons/fi';

// Componentes nuevos
import ListaSuscripcionesCliente from './ListaSuscripcionesCliente'; //nuevo componente
import SeccionSuscripciones from '../suscripciones/SeccionSuscripciones';//componente anterior 
import ClienteHeader from './components/ClienteHeader';
import ClientesRepetidos from './components/ClientesRepetidos';
import DetallesContactoFiscal from './components/DetallesContactoFiscal';
import DetallesInformacionContacto from './components/DetallesInformacionContacto';
import InformacionGeneral from './components/InformacionGeneral';
import LeadsVinculados from './components/LeadsVinculados';
import ModalCombinarClientes from './components/ModalCombinarClientes';
import ModalEliminarCliente from './components/ModalEliminarCliente';
import ModalNuevoSoporte from './components/ModalNuevoSoporte';
import PlanesFacturacionMx from './components/PlanesFacturacionMx';
import ServiciosContratados from './components/ServiciosContratados';
import useToken from 'hooks/useToken';
import { useClientNotes } from 'akasia-components/support-engine/views/TicketDetailView/hooks';
import { ClientNotesModal } from 'akasia-components/support-engine/views/TicketDetailView/componentes';

// Hooks personalizados
import useClienteDetalles from './hooks/useClienteDetalles';
import useClienteForms from './hooks/useClienteForms';
import useClienteOperaciones from './hooks/useClienteOperaciones';
import useModales from './hooks/useModales';

const DetallesCliente = () => {
    const { id } = useParams();
    const { token } = useToken();
    const [refreshSuscripcionesClave, setRefreshSuscripcionesClave] = useState(0);
    const [refreshHistorialClave, setRefreshHistorialClave] = useState(0);
    const [showModalNotasCliente, setShowModalNotasCliente] = useState(false);

    const {
        notes: clientNotes,
        isLoadingNotes: isLoadingClientNotes,
        isSavingNote: isSavingClientNote,
        createNote: createClientNote,
        updateNote: updateClientNote,
        deleteNote: deleteClientNote
    } = useClientNotes({ customerId: id, token });

    // 1. Declaramos las variables para utilizar tabs con persistencia
    const [tabActiva, setTabActivaState] = useState(() => {
        return localStorage.getItem('detallesClienteTabActiva') || 'general';
    });

    const setTabActiva = (tab) => {
        setTabActivaState(tab);
        localStorage.setItem('detallesClienteTabActiva', tab);
    };

    // Hook para formularios
    const { formPrincipal, formSoporte } = useClienteForms();


    // Hook para modales
    const {
        showModalNuevoSoporte,
        showModalEliminar,
        showModalCombinarClientes,
        showModalSeguimientoLead,
        showModalDatosFiscalesIncompletos,
        setShowModalEliminar,
        setShowModalSeguimientoLead,
        abrirModalNuevoSoporte,
        cerrarModalNuevoSoporte,
        cerrarModalEliminar,
        abrirModalDatosFiscalesIncompletos,
        cerrarModalCombinarClientes,
        setShowModalCombinarClientes,
        setShowModalDatosFiscalesIncompletos
    } = useModales();


    // Hook para manejar la lógica del cliente
    const {
        customerdetails,
        agrupacionLicencias,
        tablaRegimenFiscal,
        tablaUsoCFDI,
        countries,
        states,
        nivelSoporte,
        herramientas,
        isDistribucion,
        setIsDistribucion,
        statusSolucion,
        soporte,
        ordenes,
        setOrdenes,
        documentosCargados,
        setDocumentosCargados,
        documentos,
        cargando,
        cargandoEstado,
        cargandoFile,
        editar,
        setEditar,
        editando,
        cargandoComboBoxSoporte,
        licencias,
        polizas,
        dataFiles,
        setDataFiles,
        leadsVinculados,
        setLeadsVinculados,
        clienteActivityLogs,
        setClienteActivityLogs,
        clientesRepetidos,
        getinformaciondetalladaclientebyid,
        obtenerComboBoxSoporteTecnico,
        mostrarEstados,
        editarInfoCliente,
        eliminarCliente,
        registrarSoporteTecnico,
        combinarClientes,
        onSubmitDocFile,
        cargandoTab
    } = useClienteDetalles(id, tabActiva);

    // Hook para operaciones del cliente
    const {
        setIdClienteAkasiaACombinar,
        habilitarBtnCombinar,
        idLead,
        setIdLead,
        validarDatosFiscales,
        handleObtenerComboBoxSoporteTecnico,
        handleGuardarCliente,
        handleRegistrarSoporte,
        handleEliminarCliente,
        handleCombinarClientes,
        mensajeDatosFiscales
    } = useClienteOperaciones({
        customerdetails,
        editarInfoCliente,
        eliminarCliente,
        registrarSoporteTecnico,
        combinarClientes,
        obtenerComboBoxSoporteTecnico,
        abrirModalDatosFiscalesIncompletos,
        abrirModalNuevoSoporte,
        cerrarModalNuevoSoporte,
        cerrarModalEliminar,
        cerrarModalCombinarClientes,
        resetFormSoporte: formSoporte.reset
    });

    // El hook useClienteDetalles ya se encarga de cargar los datos cuando cambia el id o la tabActiva,
    // por lo que evitamos llamarlo doble vez para prevenir condiciones de carrera.
    const [paisSeleccionado, setPaisSeleccionado] = React.useState(customerdetails.vPais || 'Mexico');
    const handlePaisChange = (event) => {
        const nuevoPais = event.target.value;

        setPaisSeleccionado(nuevoPais);
        mostrarEstados(nuevoPais);
    };

    // Wrapper para onSubmit del formulario principal
    const onSubmit = (data) => handleGuardarCliente(id, data);

    return (
        <>
            <PageHeader
                title={"Cliente " + id + " | Informaci\u00f3n detallada"}
                className="mb-1"
            />
            {cargando ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                    <h3 className="text-primary d-flex align-items-center">
                        <Spinner className="me-2" animation="border" variant="primary" />
                        Cargando información...
                    </h3>
                </div>
            ) : (
                <>
                    <ClienteHeader
                        customerdetails={customerdetails}
                        editar={editar}
                        editando={editando}
                        setEditar={setEditar}
                        handleSubmit={formPrincipal.handleSubmit}
                        onSubmit={onSubmit}
                        reset={formPrincipal.reset}
                        ordenes={ordenes}
                        soporte={soporte}
                        validarDatosFiscales={validarDatosFiscales}
                        obtenerComboBoxSoporteTecnico={handleObtenerComboBoxSoporteTecnico}
                        setShowModalEliminar={setShowModalEliminar}
                        onOpenNotasModal={() => setShowModalNotasCliente(true)}
                        clientNotesCount={clientNotes.length}
                    />

                    {/* INFORMACIÓN GENERAL SIEMPRE VISIBLE */}
                    <Row className="g-3 mb-3 mt-1">
                        <Col lg={12}>
                            <InformacionGeneral
                                customerdetails={customerdetails}
                                editar={editar}
                                editando={editando}
                                register={formPrincipal.register}
                                errors={formPrincipal.errors}
                                ordenes={ordenes}
                                soporte={soporte}
                            />
                        </Col>
                    </Row>

                    {/* Menú de Navegación de Pestañas (Desktop) */}
                    <ul className="nav nav-pills p-2 bg-white rounded-3 mb-4 mt-3 shadow-sm border d-none d-xl-flex" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex align-items-center gap-2 px-4 py-2 fw-semi-bold rounded-pill transition-all ${tabActiva === 'general' ? 'active bg-primary text-white shadow-sm' : 'text-600 hover-bg-200 border-0'}`}
                                onClick={() => setTabActiva('general')}
                                type="button"
                                style={{ transition: 'all 0.2s ease-in-out' }}
                            >
                                <FiUser className="fs-1" />
                                <span>Información General</span>
                            </button>
                        </li>

                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex align-items-center gap-2 px-4 py-2 fw-semi-bold rounded-pill transition-all ${tabActiva === 'servicioscontratados' ? 'active bg-primary text-white shadow-sm' : 'text-600 hover-bg-200 border-0'}`}
                                onClick={() => setTabActiva('servicioscontratados')}
                                type="button"
                                style={{ transition: 'all 0.2s ease-in-out' }}
                            >
                                <FiBriefcase className="fs-1" />
                                <span>Servicios y Ordenes</span>
                            </button>
                        </li>


                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex align-items-center gap-2 px-4 py-2 fw-semi-bold rounded-pill transition-all ${tabActiva === 'soporte' ? 'active bg-primary text-white shadow-sm' : 'text-600 hover-bg-200 border-0'}`}
                                onClick={() => setTabActiva('soporte')}
                                type="button"
                                style={{ transition: 'all 0.2s ease-in-out' }}
                            >
                                <FiHeadphones className="fs-1" />
                                <span>Soporte</span>
                            </button>
                        </li>

                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex align-items-center gap-2 px-4 py-2 fw-semi-bold rounded-pill transition-all ${tabActiva === 'desarrollo' ? 'active bg-primary text-white shadow-sm' : 'text-600 hover-bg-200 border-0'}`}
                                onClick={() => setTabActiva('desarrollo')}
                                type="button"
                                style={{ transition: 'all 0.2s ease-in-out' }}
                            >
                                <FiCode className="fs-1" />
                                <span>Desarrollo</span>
                            </button>
                        </li>
                    </ul>

                    {/* Menú de Navegación de Pestañas (Mobile Bottom Nav) */}
                    <ul className="nav bg-white shadow-lg border-top d-flex d-xl-none fixed-bottom w-100 justify-content-around m-0 p-1" style={{ zIndex: 1040, paddingBottom: "env(safe-area-inset-bottom)" }}>
                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex flex-column align-items-center p-1 border-0 bg-transparent ${tabActiva === 'general' ? 'text-primary' : 'text-secondary'}`}
                                onClick={() => setTabActiva('general')}
                                type="button"
                            >
                                <FiUser className="fs-3 mb-1" />
                                <span style={{ fontSize: '0.65rem', fontWeight: tabActiva === 'general' ? 'bold' : 'normal' }}>General</span>
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex flex-column align-items-center p-1 border-0 bg-transparent ${tabActiva === 'servicioscontratados' ? 'text-primary' : 'text-secondary'}`}
                                onClick={() => setTabActiva('servicioscontratados')}
                                type="button"
                            >
                                <FiBriefcase className="fs-3 mb-1" />
                                <span style={{ fontSize: '0.65rem', fontWeight: tabActiva === 'servicioscontratados' ? 'bold' : 'normal' }}>Servicios y Ordenes</span>
                            </button>
                        </li>

                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex flex-column align-items-center p-1 border-0 bg-transparent ${tabActiva === 'soporte' ? 'text-primary' : 'text-secondary'}`}
                                onClick={() => setTabActiva('soporte')}
                                type="button"
                            >
                                <FiHeadphones className="fs-3 mb-1" />
                                <span style={{ fontSize: '0.65rem', fontWeight: tabActiva === 'soporte' ? 'bold' : 'normal' }}>Soporte</span>
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link d-flex flex-column align-items-center p-1 border-0 bg-transparent ${tabActiva === 'desarrollo' ? 'text-primary' : 'text-secondary'}`}
                                onClick={() => setTabActiva('desarrollo')}
                                type="button"
                            >
                                <FiCode className="fs-3 mb-1" />
                                <span style={{ fontSize: '0.65rem', fontWeight: tabActiva === 'desarrollo' ? 'bold' : 'normal' }}>Desarrollo</span>
                            </button>
                        </li>
                    </ul>

                    <div className="tab-content" style={{ paddingBottom: '80px' }}>
                        {cargandoTab ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                                <h3 className="text-primary d-flex align-items-center">
                                    <Spinner className="me-2" animation="border" variant="primary" />
                                    Cargando información...
                                </h3>
                            </div>
                        ) : (
                            <>
                                {/* ======================= PESTAÑA 1: GENERAL ======================= */}
                                {tabActiva === 'general' && (
                                    <>
                                        <Form noValidate onSubmit={formPrincipal.handleSubmit(onSubmit)}>
                                        <Row className="g-3 mb-3">
                                            {/* Información de Contacto */}
                                            <Col lg={12}>
                                                <Card>
                                                    <Card.Header className="bg-light">
                                                        <h5 className="mb-0">Detalles</h5>
                                                    </Card.Header>
                                                    <Card.Body className="border-top fs--1">
                                                        {editando ? (
                                                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '150px' }}>
                                                                <h4 className="text-primary d-flex align-items-center">
                                                                    <Spinner className="me-2" animation="border" variant="primary" />
                                                                    Actualizando detalles...
                                                                </h4>
                                                            </div>
                                                        ) : (
                                                            <Row>
                                                                <DetallesInformacionContacto
                                                                    customerdetails={customerdetails}
                                                                    editar={editar}
                                                                    register={formPrincipal.register}
                                                                    errors={formPrincipal.errors}
                                                                    countries={countries}
                                                                    states={states}
                                                                    cargandoEstado={cargandoEstado}
                                                                    mostrarEstados={mostrarEstados}
                                                                    documentos={documentos}
                                                                    documentosCargados={documentosCargados}
                                                                    dataFiles={dataFiles}
                                                                    setDataFiles={setDataFiles}
                                                                    setDocumentosCargados={setDocumentosCargados}
                                                                    onSubmitDocFile={onSubmitDocFile}
                                                                    cargandoFile={cargandoFile}
                                                                    handlePaisChange={handlePaisChange}
                                                                    onTelefonoChange={() => setRefreshHistorialClave(k => k + 1)}
                                                                />
                                                                <DetallesContactoFiscal
                                                                    customerdetails={customerdetails}
                                                                    editar={editar}
                                                                    register={formPrincipal.register}
                                                                    errors={formPrincipal.errors}
                                                                    setValue={formPrincipal.setValue}
                                                                    tablaRegimenFiscal={tablaRegimenFiscal}
                                                                    tablaUsoCFDI={tablaUsoCFDI}
                                                                    isDistribucion={isDistribucion}
                                                                    setIsDistribucion={setIsDistribucion}
                                                                    paisSeleccionado={paisSeleccionado}
                                                                />
                                                            </Row>
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            {/* Leads y Clientes Repetidos */}
                                            <LeadsVinculados
                                                leadsVinculados={leadsVinculados}
                                                setIdLead={setIdLead}
                                                setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                                            />
                                            <ClientesRepetidos
                                                clientesRepetidos={clientesRepetidos}
                                                setIdClienteAkasiaACombinar={setIdClienteAkasiaACombinar}
                                                setShowModalCombinarClientes={setShowModalCombinarClientes}
                                            />

                                            {/* Historial de Movimientos */}
                                            <Col lg={12}>
                                                <ErrorBoundary>
                                                    <HistorialMovimientosCliente
                                                        idCliente={id}
                                                        setClienteActivityLogs={setClienteActivityLogs}
                                                        clienteActivityLogs={clienteActivityLogs}
                                                        refreshKey={refreshHistorialClave}
                                                    />
                                                </ErrorBoundary>
                                            </Col>
                                        </Row>
                                    </Form>

                                    <Row className="g-3 mb-3 mt-1">
                                        <Col lg={12}>
                                            <ErrorBoundary>
                                                <SeccionArchivosCliente
                                                    idCliente={id}
                                                    setClienteActivityLogs={setClienteActivityLogs}
                                                />
                                            </ErrorBoundary>
                                        </Col>
                                    </Row>
                                </>)}

                                {/* ======================= PESTAÑA 3: SERVICIOS Y ORDENES ======================= */}
                                {tabActiva === 'servicioscontratados' && (
                                    <>
                                        <Row className="g-3 mb-3">
                                            <Col lg={12}>
                                                <ErrorBoundary>
                                                    <OrdenesCliente
                                                        idCliente={id}
                                                        setOrdenes={setOrdenes}
                                                        ordenes={ordenes}
                                                    />
                                                </ErrorBoundary>
                                            </Col>
                                        </Row>

                                        <ServiciosContratados
                                            agrupacionLicencias={agrupacionLicencias}
                                            licencias={licencias}
                                            polizas={polizas}
                                            idCliente={id}
                                            customer={customerdetails}
                                            onSuscripcionCreada={async () => {
                                                setRefreshSuscripcionesClave(k => k + 1);
                                                await getinformaciondetalladaclientebyid();
                                            }}
                                        />

                                        <Row className="g-3 mb-3">
                                            <Col lg={12}>
                                                <ErrorBoundary>
                                                    <ListaSuscripcionesCliente idCliente={id} />
                                                </ErrorBoundary>
                                            </Col>
                                        </Row>

                                        <Row className="g-3 mb-3">
                                            <Col lg={12}>
                                                <ErrorBoundary>
                                                    <PlanesFacturacionMx
                                                        idCliente={id}
                                                        onPlanAgregado={() => setRefreshHistorialClave(k => k + 1)}
                                                    />
                                                </ErrorBoundary>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {/* ======================= PESTAÑA 4: SOPORTE ======================= */}
                                {tabActiva === 'soporte' && (
                                    <Row className="g-3 mb-3">
                                        <Col lg={12}>
                                            <ErrorBoundary>
                                                <SoporteTecnico
                                                    agrupacionLicencias={agrupacionLicencias}
                                                    setHabilitarBtnCombinar={setShowModalCombinarClientes}
                                                    setShowModalCombinarClientes={setShowModalCombinarClientes}
                                                    idClienteAkasia={id}
                                                    emailCliente={customerdetails?.vEmail}
                                                />
                                            </ErrorBoundary>
                                        </Col>
                                    </Row>
                                )}

                                {/* ======================= PESTAÑA 4: DESARROLLO ======================= */}
                                {tabActiva === 'desarrollo' && (

                                    <Row className="g-3 mb-3">
                                        <Col lg={12}>
                                            <ErrorBoundary>
                                                <SeccionSuscripciones
                                                    idCliente={id}
                                                    refreshKey={refreshSuscripcionesClave}
                                                    onPagoManualRegistrado={getinformaciondetalladaclientebyid}
                                                />
                                            </ErrorBoundary>
                                        </Col>
                                    </Row>

                                )}
                            </>)}

                    </div>

                    {/* Modales */}
                    <ModalNuevoSoporte
                        showModalNuevoSoporte={showModalNuevoSoporte}
                        setShowModalNuevoSoporte={cerrarModalNuevoSoporte}
                        cargandoComboBoxSoporte={cargandoComboBoxSoporte}
                        handleSubmit={formSoporte.handleSubmit}
                        onSubmitNuevoSoporte={handleRegistrarSoporte}
                        register={formSoporte.register}
                        errors={formSoporte.errors}
                        nivelSoporte={nivelSoporte}
                        herramientas={herramientas}
                        statusSolucion={statusSolucion}
                        reset={formSoporte.reset}
                    />

                    <ModalEliminarCliente
                        showModalEliminar={showModalEliminar}
                        setShowModalEliminar={setShowModalEliminar}
                        handleSubmit={formPrincipal.handleSubmit}
                        onSubmitEliminar={handleEliminarCliente}
                        reset={formPrincipal.reset}
                    />

                    <ModalCombinarClientes
                        showModalCombinarClientes={showModalCombinarClientes}
                        setShowModalCombinarClientes={setShowModalCombinarClientes}
                        customerdetails={customerdetails}
                        habilitarBtnCombinar={habilitarBtnCombinar}
                        combinarClientes={handleCombinarClientes}
                    />

                    <ModalSeguimientoLead
                        showModal={showModalSeguimientoLead}
                        setShowModal={setShowModalSeguimientoLead}
                        idLead={idLead}
                        setIdLead={setIdLead}
                        leadsVinculados={leadsVinculados}
                        setLeadsVinculados={setLeadsVinculados}
                    />

                    <ModalDatosFiscalesIncompletos
                        showModalDatosFiscalesIncompletos={showModalDatosFiscalesIncompletos}
                        setShowModalDatosFiscalesIncompletos={setShowModalDatosFiscalesIncompletos}
                        mensaje={mensajeDatosFiscales}
                    />

                    <ClientNotesModal
                        show={showModalNotasCliente}
                        onClose={() => setShowModalNotasCliente(false)}
                        customerId={id}
                        customerName={customerdetails.vNombreCliente}
                        notes={clientNotes}
                        isLoadingNotes={isLoadingClientNotes}
                        isSavingNote={isSavingClientNote}
                        createNote={createClientNote}
                        updateNote={updateClientNote}
                        deleteNote={deleteClientNote}
                    />
                </>
            )}
        </>
    );
};

export default DetallesCliente;
